<template>
    <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" class="h-dialog2">
		<div class="leaderBox" v-if="showOrhide3">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt3">
			<img src="../../assets/images/pop/cjxm/cjxm.jpg" class="steps step11" v-if="status3==11">
			<div class="stepbtn" @click="nextStep3(status3)">
				{{status3==11?"我知道了":"我知道了"}}
			</div>
			<div class="bottomTip">
				<el-checkbox v-model="checked3">下次不再提示</el-checkbox>
			</div>
		</div>
      <div class="h-dialogImg">
          <div class="h-disTable">
              <div class="h-tableCell">
                  <h1>选择项目类型</h1>
                  <p>Choose Style</p>
              </div>
          </div>
      </div>
      <div class="h-formLines" style="padding: 20px 30px;">
          <div class="xuqiuBoxList">
              <div class="xuqiulist" :class="{'active':xuqiudex==index}" v-for="(item,index) in xuqiuList"
                    v-auth="'xiangmu'+index"
                    :key="index" @click="xuqiuGo(index)">
                  <p>{{item}}</p>
                  <img v-if="xuqiudex==index" src="../../assets/images/checkBox.png"
                        style="margin-left:20px;"/>
              </div>
          </div>
          <div class="xuqiutext" style="margin-top:30px;"><span style="color:#f46071">*</span>内销项目是为内销订单下单做准备，可以进行特价申请，进而生成特价订单。
          </div>
          <div class="xuqiutext"><span style="color:#f46071">*</span>外销项目是为外销订单下单做准备，可以进行特价申请，进而生成特价订单。
          </div>
          <div class="xuqiutext"><span style="color:#f46071">*</span>采购项目是指用户有意向购买的产品属于海尔非自产产品，销售人员需要向采购部分人员发起采购产品项目。
          </div>
          <div class="xuqiutext"><span style="color:#f46071">*</span>展会项目是指创建一个展会，展会中的产品以特价出售给展会范围内的经销商。
          </div>
          <div style="display:flex;justify-content:center">
              <el-button class="h-btn h-formBtn h-bgblue2" @click="gotonewProject()">确定</el-button>
          </div>
      </div>
  </el-dialog>
</template>

<script>
	import ss from "../../api/SystemService";
    export default {
        name: "projectAdd",
        data(){
            return{
				showOrhide3: false,
				toshow3: "projectAdd1",
				checked3: true,
				status3: 11,
                dialogFormVisible1: true,
                xuqiudex:4,
                xuqiuList: ['内销项目', '外销项目', '采购项目','展会项目']
            }
        },
        methods:{
			showzhezhao(){
				ss.salesList.toshow(this.toshow3).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide3 = false;
				    }else{
				        this.showOrhide3 = true;
				    }
				})
			},
            xuqiuGo(index) {
                this.xuqiudex = index;
            },
            gotonewProject() {
                console.log(this.xuqiudex)
                //项目类型:1-展会,2-外销,3-内销,4-租赁,5-采购,6-服务项目
                if (this.xuqiudex == 0) {
                    //内销
                    //订单关联漏斗 当前登录是否在 配置表中
                    var item = localStorage.getItem("userId");
                    ss.loudnew.isAgentOrderLoud(item).then(res=>{
                      debugger
                      if (res.msg == '2'){
                        this.$router.push({path:'/xiangmu/newProject2',query:{protype:3}})
                      }else {
                        this.$router.push({path:'/xiangmu/newProject',query:{protype:3}})
                      }
                    });
                    this.dialogFormVisible1 = false;
                } else if (this.xuqiudex == 1) {
                    //外销
                    this.$router.push({path:'/xiangmu/newProject',query:{protype:2}})
                    this.dialogFormVisible1 = false;
                } else if (this.xuqiudex == 2) {
                    //采购项目
                    this.$router.push({path:'/xiangmu/newProject',query:{protype:5}})
                    this.dialogFormVisible1 = false;
                }else if (this.xuqiudex == 3) {
                    //展会项目
                    this.$router.push({path:'/xiangmu/newProject',query:{protype:1}})
                    this.dialogFormVisible1 = false;
                }
                this.$emit('imgfalse4');
            },
			// 弹窗关闭
			closeIt3() {
				this.showOrhide3 = false;
				if (this.checked3) {
					ss.salesList.toshow(this.toshow3,this.checked3).then(rd => {
						console.log(rd)
						this.showOrhide3 = false;
					})
				}else{
					ss.salesList.toshow(this.toshow3,this.checked3).then(rd => {
						console.log(rd)
						this.showOrhide3 = false;
					})
				}
			},
			nextStep3(i) {
				console.log(i)
				if (this.status3 == 11) {
					if (this.checked3) {
						ss.salesList.toshow(this.toshow3,this.checked3).then(rd => {
							console.log(rd)
							this.showOrhide3 = false;
						})
					} else {
						ss.salesList.toshow(this.toshow3,this.checked3).then(rd => {
							console.log(rd)
							this.showOrhide3 = false;
						})
					}
				}
			},
        },
		mounted() {

		},
		created() {
			this.showzhezhao()
		},
        props: {
            dialogVisible: {
                type: Boolean,
            },
        }
    }
</script>

<style scoped>
.xuqiuBoxList {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }

    .xuqiuBoxList .xuqiulist {
        width: 200px;
        height: 62px;
        border-radius: 4px;
        background: #fff;
        border: 1px solid #959595;
        text-align: center;
        line-height: 62px;
        color: #989898;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
    }

    .xuqiuBoxList .xuqiulist:first-child {
        margin-left: 0
    }

    .xuqiuBoxList .xuqiulist.active {
        background: #238cfd;
        border: 1px solid #238cfd;
        color: #fff;
    }

    .xuqiutext {
        color: #bcbcbc;
        font-size: 14px;
        margin-bottom: 14px;
    }
</style>
<style scoped lang="scss">
	.bottomTip {
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}

	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}

	.leaderBox {
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;

		.leaderbg {
			width: 100%;
			height: 100%;

		}

		.steps {
			position: absolute;
			z-index: 1;
		}

		.step11 {
			left: 0;
			top: 0;
		}


		.stepbtn {
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}

		.closeIt {
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>
